import React from "react";

function DropDownArrow(props) {
    return (
        <svg {...props}  width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" >
            <path
                d="M11.6259 0.299142C10.9532 -0.336441 10.0866 0.343384 9.37984 1.13759L5.94312 4.99533L1.78521 0.3013C1.5762 0.1072 1.30639 0 1.02688 0C0.747369 0 0.477562 0.1072 0.268552 0.3013C0.0941296 0.548087 9.53674e-07 0.846886 9.53674e-07 1.15378C9.53674e-07 1.46067 0.0941296 1.75947 0.268552 2.00626L5.3736 7.73729C5.44545 7.82003 5.53305 7.88615 5.63077 7.93139C5.7285 7.97663 5.83418 8 5.94105 8C6.04792 8 6.15361 7.97663 6.25133 7.93139C6.34906 7.88615 6.43666 7.82003 6.50851 7.73729L11.6259 1.99655C11.7427 1.89166 11.8366 1.76171 11.9012 1.61553C11.9657 1.46934 11.9994 1.31034 12 1.14932C12.0006 0.988307 11.968 0.829042 11.9046 0.682346C11.8411 0.535649 11.7482 0.404957 11.6321 0.299142H11.6259Z"
                fill="#6B7073"
            />
        </svg>
    );
}

export default DropDownArrow;
